import { TextField } from '@mui/material';
import { useCallback, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { connect } from 'react-redux';

import { notify } from '@/actions/ui';
import { shortenUrl } from '@/actions/url';
import { primary, white } from '@/theme/colors';

import Button from '../Button';

function ShareableLink(props: any) {
  const [url, setUrl] = useState(props.url);
  const [loading, setLoading] = useState(false);
  const [shortened, setShortened] = useState(false);
  const {
    enableShorten = true,
    label = 'LinkedIn referral URL',
    inputStyle,
    buttonStyle,
    shortenUrl,
    notify,
  } = props;

  const shorten = useCallback(async () => {
    if (loading) return;

    setLoading(true);

    try {
      const newUrl = await shortenUrl(url);
      setUrl(`https://${newUrl}`);
      setShortened(true);
    } catch {
      notify('Failed to shorten URL', 'error');
      setShortened(false);
    } finally {
      setLoading(false);
    }
  }, [loading, shortenUrl, url, notify]);

  return (
    <div style={{ display: 'flex', alignItems: 'baseline' }}>
      <TextField
        label={label}
        value={loading ? 'Shortening...' : url}
        style={{ flex: 1, marginRight: 10, ...inputStyle }}
      />
      <CopyToClipboard text={url}>
        <Button size="small" backgroundColor={white} fontColor={primary} variant="inverted">
          Copy Link
        </Button>
      </CopyToClipboard>
      {enableShorten && !shortened && (
        <Button
          size="small"
          disabled={loading}
          onClick={shorten}
          style={{ marginLeft: 10, ...buttonStyle }}
          backgroundColor={white}
          fontColor={primary}
          variant="inverted"
        >
          Shorten
        </Button>
      )}
    </div>
  );
}

export default connect(undefined, {
  shortenUrl,
  notify,
})(ShareableLink);
